import moment from "moment";

export default {
  entityName: "lost",
  upsert: "full",
  filterStorage: {},
  pagination: {
    rowsPerPage: 10,
    page: 1,
    sortBy: "id",
    descending: true,
  },
  fields: [
    // ── Lost Date ─────────────────────────────────────────────────────────────
    {
      value: "lost_date",
      text: "Lost Date",
      type: "date",
      render: (item) =>
        item.lost_date ? moment(item.lost_date).format("YYYY-MM-DD") : "",
      validators: ['required']
    },

    // ── Protocol ──────────────────────────────────────────────────────────────
    {
      value: "protocol_id",
      text: "Protocol",
      title: "name",
      render: (item) => (item.protocol && item.protocol.name) || "",
      readonly: true
    },

    // ── Site ──────────────────────────────────────────────────────────────────
    {
      value: "site_id",
      text: "Site",
      title: "name",
      readonly: true,
      render: (item) =>
        item.site ? `${item.site.city} – ${item.site.name}` : ""
    },

    // ── Site Req/Ret ──────────────────────────────────────────────────────────
    {
      value: "type_ref",
      text: "Site Req/Ret",
            render: (item) => {
        if (!item.type || !item.type_id) return "-";
        return item.type === "request" ? 'Site Request' : 'Site Return';
      },
      readonly: (item) => !!item.id,
    },

    // ── Campi non visibili in tabella (usati nell'upsert/form) ────────────────
    {
      value: "type_id",
      text: "Ref ID",
      type: "text",
      visible: false,
    },
    {
      value: "_filename",
      text: "Lost documentation",
      type: "file",
      visible: (item, state) =>
        !!(item.id && ["Administrator", "EMN User"].includes(state.user.role)),
    },
    {
      value: "filename",
      text: "Filename",
      visible: false,
    },
  ],
  actions: ["upsert", "audit", "download", "remove"],
};
